import { useCallback, useState } from 'react';

function useHovered() {
  const [hovered, setHovered] = useState(false);

  const onMouseMove = useCallback(() => {
    setHovered(true);
  }, []);

  return { hovered, onMouseMove };
}

export default useHovered;
